<h2 matDialogTitle class="m-b-0">{{HeaderName}}</h2>
<app-company-breadcrum></app-company-breadcrum>
<div mat-dialog-content id="baja-edit-card" clasEmployeeFormGroups="m-t-10">
    <form class="form" role="form" [formGroup]="EmployeeFormGroup" autocomplete="off">
        <!-- Datos personales -->
        <div class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border m-b-10 d-block">
            <div>
                <label class="b-t-l">Datos personales</label>
            </div>
            <div fxLayout="row" fxFlex="0 1 auto" class="m-t-5">
                <div class="m-r-5 maxw15">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always" hideRequiredMarker>
                            <mat-label>Nombre</mat-label>
                            <input matInput formControlName="Nombre" class="p-b-2">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(EmployeeFormGroup.get('Nombre').dirty || EmployeeFormGroup.get('Nombre').touched)">
                            <span *ngIf="EmployeeFormGroup.get('Nombre').errors" class="validation-span font-88">El
                                nombre es
                                obligatorio</span>
                        </mat-error>
                    </div>
                </div>
                <div class="m-r-5 maxw20">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always" hideRequiredMarker>
                            <mat-label>Apellidos</mat-label>
                            <input matInput formControlName="Apellidos" class="p-b-2">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(EmployeeFormGroup.get('Apellidos').dirty || EmployeeFormGroup.get('Apellidos').touched)">
                            <span *ngIf="EmployeeFormGroup.get('Apellidos').errors" class="validation-span font-88">El
                                apellidos es obligatorio</span>
                        </mat-error>
                    </div>
                </div>
                <div class="m-r-10">
                    <mat-form-field class="w-140" floatLabel="always">
                        <mat-label>Fecha de nacimiento</mat-label>
                        <input formControlName="BirthDate" matInput [matDatepicker]="birthDate"
                            (click)="birthDate.open()">
                        <mat-datepicker-toggle matSuffix [for]="birthDate"></mat-datepicker-toggle>
                        <mat-datepicker #birthDate></mat-datepicker>
                    </mat-form-field>
                    <mat-error class="m-t--5"
                        *ngIf="(EmployeeFormGroup.get('BirthDate').dirty || EmployeeFormGroup.get('BirthDate').touched) && EmployeeFormGroup.get('BirthDate').invalid">
                        <span *ngIf="EmployeeFormGroup.get('BirthDate').errors.NoAnAdult"
                            class="validation-span font-88">Debe
                            ser mayor de 16 años.</span>
                    </mat-error>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10 maxw20">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always">
                            <mat-label>NIF</mat-label>
                            <input matInput maxlength="10" formControlName="Nif" class="p-b-2">
                        </mat-form-field>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always">
                            <mat-label>Sexo</mat-label>
                            <mat-select formControlName="Sexo">
                                <mat-option value="HOMBRE">HOMBRE</mat-option>
                                <mat-option value="MUJER">MUJER</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>

        <!--  -->
        <div class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border m-b-10 d-block">
            <div>
                <label class="b-t-l">Datos profesionales</label>
            </div>
            <div fxLayout="row" fxFlex="0 1 auto" class="m-t-5">

                <div class="m-r-5 maxw20">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always">
                            <mat-label>Ref. Trabajador</mat-label>
                            <input matInput formControlName="RefTrabajador" class="p-b-2">
                        </mat-form-field>
                    </div>
                </div>

                <div class="m-r-5 maxw15">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100"  floatLabel="always">
                            <mat-label>Puesto</mat-label>
                            <input matInput formControlName="Position" class="p-b-2 m-t-2">
                        </mat-form-field>
                    </div>
                </div>
                
                <!-- <div class="widget m-t-15 puesto-check" fxFlex="100" fxFlex.gt-sm="18">
                        <input (change)="PuestoChangeEvent($event.target.checked)" type="checkbox"  [checked]="isPuestoUrgente" class="p-b-2 m-t-5 m-l-5">
                        <label>Urgente por puesto</label>
                </div> -->
                <div class="widget d-flex m-t-15" fxFlex="100" fxFlex.gt-sm="18">
                    <label class="tebex-checkbox form-check">
                        <input (change)="PuestoChangeEvent($event.target.checked)" type="checkbox"  [checked]="isPuestoUrgente" class="p-b-2 m-t-5 m-l-5">
                        <span class="checkmark"></span>
                    </label>
                    <div class="form-label">Urgente por puesto</div>
                </div>

                <div class="m-r-5 w20">
                    <div class="example-form">
                        <mat-form-field class=" w100">
                            <mat-label>F. Antigüedad</mat-label>
                            <input matInput formControlName="FAntiguedad" [matDatepicker]="FAntiguedad"
                                (click)="FAntiguedad.open()">
                            <mat-datepicker-toggle matSuffix [for]="FAntiguedad"></mat-datepicker-toggle>
                            <mat-datepicker #FAntiguedad></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <div class="m-r-5 w20">
                    <div class="example-form">
                        <mat-form-field class=" w100">
                            <mat-label>F. Fin Contrato</mat-label>
                            <input matInput formControlName="FFinContrato" [matDatepicker]="FFinContrato"
                                (click)="FFinContrato.open()">
                            <mat-datepicker-toggle matSuffix [for]="FFinContrato"></mat-datepicker-toggle>
                            <mat-datepicker #FFinContrato></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- LOPD -->
        <div class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border m-b-10 d-block">
            <div>
                <label class="b-t-l">LOPD</label>
            </div>
            <div fxLayout="row" fxFlex="0 1 auto" class="m-t-5">
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always">
                            <mat-label>Tipo consentimiento</mat-label>
                            <mat-select formControlName="TipoConsentimiento">
                                <mat-option value="E">Escrito</mat-option>
                                <mat-option value="G">Grabado</mat-option>
                                <mat-option value="EG">Grabado y Escrito </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10">
                    <div class="example-form">
                        <mat-form-field fxFlex="100" fxFlex.gt-sm="100" class="example-full-width" floatLabel="always">
                            <mat-label>Consentimiento</mat-label>
                            <mat-select formControlName="Consentimiento">
                                <mat-option value="S">Firmado</mat-option>
                                <mat-option value="E">Entregado o Grabado</mat-option>
                                <mat-option value="N">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="widget d-flex m-t-15" fxFlex="100" fxFlex.gt-sm="18">
                    <label class="tebex-checkbox form-check">
                        <input (change)="TeleCanceladoChangeEvent($event.target.checked)" type="checkbox"  [checked]="isTeleCancelado" class="p-b-2 m-t-5 m-l-5">
                        <span class="checkmark"></span>
                    </label>
                    <div class="form-label">Teléfono Cancelado</div>
                </div>

            </div>
        </div>

        <!-- Teléfonos -->
        <div *ngIf="!isTeleCancelado" class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border m-b-10">
            <div>
                <label class="b-t-l">Teléfonos</label>
            </div>
            <div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10 maxw20">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <input type="tel" matInput formControlName="Telephone1" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(EmployeeFormGroup.get('Telephone1').dirty || EmployeeFormGroup.get('Telephone1').touched) && EmployeeFormGroup.get('Telephone1').invalid">
                            <span *ngIf="EmployeeFormGroup.get('Telephone1').errors" class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10 maxw20">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <input type="tel" matInput formControlName="Telephone2" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(EmployeeFormGroup.get('Telephone2').dirty || EmployeeFormGroup.get('Telephone2').touched) && EmployeeFormGroup.get('Telephone2').invalid">
                            <span *ngIf="EmployeeFormGroup.get('Telephone2').errors" class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10 maxw20">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <input type="tel" matInput formControlName="Movil" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(EmployeeFormGroup.get('Movil').dirty || EmployeeFormGroup.get('Movil').touched) && EmployeeFormGroup.get('Movil').invalid">
                            <span *ngIf="EmployeeFormGroup.get('Movil').errors" class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="20" class="m-r-10 maxw20">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <mat-label>Fac. por trab.</mat-label>
                            <input type="tel" matInput formControlName="Telephone4" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(EmployeeFormGroup.get('Telephone4').dirty || EmployeeFormGroup.get('Telephone4').touched) && EmployeeFormGroup.get('Telephone4').invalid">
                            <span *ngIf="EmployeeFormGroup.get('Telephone4').errors" class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>

        <div class="row p-0">
            <!-- Directions -->
            <div class="trabajador-panel d-block cp-fix m-b-10">
                <div class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border d-block">
                    <label class="b-t-l m-b-10">Dirección</label>
                    <div class="d-flex m-b-10 flexColumn">
                        <div fxFlex="100" >
                            <fieldset class="d-block">
                                <legend>Dirección 01</legend>
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <div class="example-form m-t-5">
                                            <mat-form-field class="example-full-width" floatLabel="always">
                                                <mat-label>Dirección</mat-label>
                                                <input matInput formControlName="Direction1" class="upper-case">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <mat-form-field class="display-flex m-b-5" floatLabel="always">
                                            <mat-label>Provincia</mat-label>
                                            <mat-select formControlName="Province1">
                                                <mat-option *ngFor="let province of ProvinceList"
                                                    [value]="province.value"
                                                    (click)="GetProvinceCities(province.value)">
                                                    {{province.viewValue}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <div class="example-form ">
                                            <mat-form-field class="example-full-width" floatLabel="always">
                                                <mat-label>Población</mat-label>
                                                <input type="text" class="upper-case" aria-label="Assignee" matInput
                                                    formControlName="City1" [matAutocomplete]="auto">
                                                <mat-autocomplete #auto="matAutocomplete">
                                                    <mat-option *ngFor="let city of directionService.cities"
                                                        [value]="city.nombre">
                                                        {{city.nombre}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <div class="example-form">
                                            <div class="widget position-relative">
                                                <mat-form-field class="example-full-width" floatLabel="always">
                                                    <mat-label>C.P.</mat-label>
                                                    <input matInput formControlName="PostalCode1" maxlength="5">
                                                </mat-form-field>
                                                <mat-error
                                                    *ngIf="(EmployeeFormGroup.get('PostalCode1') && (EmployeeFormGroup.get('PostalCode1').dirty || EmployeeFormGroup.get('PostalCode1').touched)) && EmployeeFormGroup.get('PostalCode1').invalid">
                                                    <span
                                                        *ngIf="EmployeeFormGroup.get('PostalCode1').errors.NotAPostalCode || EmployeeFormGroup.get('PostalCode1').errors.pattern"
                                                        class="validation-span">
                                                        C.P. inválido
                                                    </span>
                                                    <span
                                                        *ngIf="EmployeeFormGroup.get('PostalCode1').errors.noPostalCodeExists">
                                                        El Código postal no es correcto
                                                    </span>
                                                </mat-error>
                                                <div class="c-p-loader check-mark">
                                                    <mat-icon *ngIf="Direction1Validated"
                                                        class="mat-icon material-icons f-s-19" color="accent">
                                                        check
                                                    </mat-icon>
                                                    <mat-progress-spinner *ngIf="Direction1Validating" [diameter]="20"
                                                        color="accent" mode="indeterminate">
                                                    </mat-progress-spinner>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div fxFlex="100" >
                            <fieldset class="d-block">
                                <legend>Dirección 02</legend>
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <div class="example-form m-t-5">
                                            <mat-form-field class="example-full-width" floatLabel="always">
                                                <mat-label>Dirección</mat-label>
                                                <input matInput formControlName="Direction2" class="upper-case">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <mat-form-field class="display-flex m-b-5 " floatLabel="always">
                                            <mat-label>Provincia</mat-label>
                                            <mat-select formControlName="Province2">
                                                <mat-option *ngFor="let province of ProvinceList"
                                                    [value]="province.value"
                                                    (click)="GetProvince2Cities(province.value)">
                                                    {{province.viewValue}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <div class="example-form">
                                            <mat-form-field class="example-full-width" floatLabel="always">
                                                <mat-label>Población</mat-label>
                                                <input type="text" class="upper-case" aria-label="Assignee" matInput
                                                    formControlName="City2" [matAutocomplete]="autoPobalicion">
                                                <mat-autocomplete #autoPobalicion="matAutocomplete">
                                                    <mat-option *ngFor="let city of directionService.cities2"
                                                        [value]="city.nombre">
                                                        {{city.nombre}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                                        <div class="example-form">
                                            <div class="widget position-relative">
                                                <mat-form-field class="example-full-width" floatLabel="always">
                                                    <mat-label>C.P.</mat-label>
                                                    <input matInput formControlName="PostalCode2" maxlength="5">
                                                </mat-form-field>
                                                <mat-error
                                                    *ngIf="(EmployeeFormGroup.get('PostalCode2') && (EmployeeFormGroup.get('PostalCode2').dirty || EmployeeFormGroup.get('PostalCode2').touched)) && EmployeeFormGroup.get('PostalCode2').invalid">
                                                    <span
                                                        *ngIf="EmployeeFormGroup.get('PostalCode2').errors.NotAPostalCode || EmployeeFormGroup.get('PostalCode2').errors.pattern"
                                                        class="validation-span">
                                                        C.P. inválido
                                                    </span>
                                                    <span
                                                        *ngIf="EmployeeFormGroup.get('PostalCode2').errors.noPostalCodeExists">
                                                        El Código postal no es correcto
                                                    </span>
                                                </mat-error>
                                                <div class="c-p-loader check-mark">
                                                    <mat-icon *ngIf="Direction2Validated"
                                                        class="mat-icon material-icons f-s-19" color="accent">
                                                        check
                                                    </mat-icon>
                                                    <mat-progress-spinner *ngIf="Direction2Validating" [diameter]="20"
                                                        color="accent" mode="indeterminate">
                                                    </mat-progress-spinner>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="100">
                        <mat-form-field class="example-full-width" floatLabel="always">
                            <mat-label>Obs. Dirección</mat-label>
                            <textarea matInput class="example-full-width obs-direccion"
                                formControlName="ObsDireccion"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Atributos -->
            <div class="trabajador-panel m-b-10">
                <div fxFlex="100" fxFlex.gt-sm="100">
                    <div class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border d-block">
                        <label class="b-t-l">Atributos</label>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
                            <edit-trabajador-attribute [createNewEmployeeFormGroup]="this.EmployeeFormGroup"
                                [empresaId]="this.empresaId" [empresaDetails]="this.empresaDetails" id="trabajadorPaneAttributes">
                            </edit-trabajador-attribute>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Observaciones -->
            <div class="fuse-card auto-width mat-elevation-z2 p-0 acuation-card-border m-b-10">
                <label class="b-t-l">Observaciones</label>
                <mat-form-field class="example-full-width width-100percent obs-edit-emp" floatLabel="always">
                    <textarea matInput class="example-full-width obs-direccion"
                        formControlName="Observation"></textarea>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>

<mat-progress-bar class="m-t-10" mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
<div class="text-a-r p-t-10">
    <button class="m-r-15" mat-raised-button color="accent" (click)="UpdateEmplooyeeData()">Guardar</button>
    <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
</div>